import React, { Fragment, useEffect, useState } from 'react';
import { Form } from 'antd';
import get from 'lodash/get';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';
import { DEFAULT_AVATAR, PENDING_ID } from '@gtintel/platform-constants';
import { useStores } from '@gtintel/platform-stores';
import PartnerCard from '../PartnerCard';
import PartnerModal from '../PartnerModal';
import styles from './style.module.scss';
const PartnerState = props => {
  const {
    partnerStore
  } = useStores();
  const {
    projectPartner
  } = partnerStore;
  const [visible, setVisible] = useState(false);
  const {
    project
  } = props;
  const router = useRouter();
  const projectId = get(router, 'query.id', '');
  useEffect(() => {
    if (projectId) {
      partnerStore.getProjectPartner(Number(projectId));
    }
  }, [projectId]);
  return <Fragment>
      {!!projectPartner?.id && Number(project?.status) > Number(PENDING_ID) && <Form.Item label="Matched Network Partner" labelAlign="left" className={styles.partnerCardWrap}>
          <a href="#" onClick={() => setVisible(true)}>
            <PartnerCard avatar={projectPartner?.avatar ?? DEFAULT_AVATAR} name={projectPartner?.full_name} timezone={projectPartner?.timezone} />
          </a>
        </Form.Item>}
      <PartnerModal partner={projectPartner} isOpen={visible} onCancel={() => setVisible(false)} />
    </Fragment>;
};
export default observer(PartnerState);